import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

Vue.use(Router);

const routes = [
  {
    path: "*",
    component: () => import("./layouts/Default.vue"),
    children: [
      {
        path: "sso",
        name: "sso",
        component: () => import("./views/SSO.vue"),
        meta: {
          title: "SSO",
          public: true,
        },
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("./views/Dashboard.vue"),
        meta: {
          title: "Dashboard",
        },
      },
      {
        path: "documents",
        name: "documents",
        component: () => import("./views/DocumentsArea.vue"),
        meta: {
          title: "Area Documentale",
        },
      },
      {
        path: "downloadarea",
        name: "downloadarea",
        component: () => import("./views/DownloadArea.vue"),
        meta: {
          title: "Area Download",
        },
      },
      {
        path: "download-csv-xls",
        name: "download-csv-xls",
        component: () => import("./views/DownloadCsvXls.vue"),
        meta: {
          title: "Scarica dati aggregati csv/xlsx",
        },
      },
      {
        path: "gestione-area-documentale",
        name: "gestione-area-documentale",
        component: () => import("./views/DocumentsAreaManagement.vue"),
        meta: {
          title: "Gestione Area Documentale",
        },
      },
      {
        path: "terms-management",
        name: "terms-management",
        component: () => import("./views/TermsManagement.vue"),
        meta: {
          title: "Gestione Vocabolario",
        },
      },
      {
        path: "libraries-management",
        name: "libraries-management",
        component: () => import("./views/LibrariesManagement.vue"),
        meta: {
          title: "Librerie Termini",
        },
      },
      {
        path: "library-management/:slug",
        name: "library-management",
        component: () => import("./views/LibraryManagement.vue"),
        meta: {
          title: "Libreria Termini",
        },
      },
      {
        path: "management-territorial-areas",
        name: "management-territorial-areas",
        component: () => import("./views/ManagementTerritorialAreas.vue"),
        meta: {
          title: "Gestione Ambiti Territoriali",
        },
      },
      {
        path: "iniziative-validations",
        name: "iniziative-validations",
        component: () => import("./views/ValidationIniziative.vue"),
        meta: {
          title: "Validazione Iniziative",
        },
      },
      {
        path: "operational-plans-sent",
        name: "operational-plans-sent",
        component: () => import("./views/OperationalPlansSent.vue"),
        meta: {
          title: "Piani Operativi Inviati",
        },
      },
      {
        path: "ambit-plan",
        name: "ambit-plan",
        component: () => import("./views/AmbitPlan.vue"),
        meta: {
          title: "Piano D'Ambito",
        },
      },
      {
        path: "strategy-summary",
        name: "strategy-summary",
        component: () => import("./views/StrategySummary.vue"),
        meta: {
          title: "Riassunto Strategia",
        },
      },
      {
        path: "macro-products-management",
        name: "macro-products-management",
        component: () => import("./views/MacroProductsManagement.vue"),
        meta: {
          title: "Prodotti Turistici",
        },
      },
      {
        path: "survey/:type",
        name: "survey",
        component: () => import("./views/Survey.vue"),
        meta: {
          title: "Sondaggio",
        },
      },
      {
        path: "survey/:type/:surveyId",
        name: "edit-survey",
        component: () => import("./views/Survey.vue"),
        meta: {
          title: "Modifica Sondaggio",
        },
      },
      {
        path: "survey/:type/:surveyId/:actionType",
        name: "edit-survey-action",
        component: () => import("./views/Survey.vue"),
        meta: {
          title: "Modifica Sondaggio",
        },
      },
      {
        path: "governance",
        name: "governance",
        component: () => import("./views/Governance.vue"),
        meta: {
          title: "Governance dell'ambito",
        },
      },
      {
        path: "products-markets",
        name: "products-markets",
        component: () => import("./views/ProductsMarkets.vue"),
        meta: {
          title: "Prodotti e mercati",
        },
      },
      {
        path: "management",
        name: "management",
        component: () => import("./views/Management.vue"),
        meta: {
          title: "Management delle destinazioni",
        },
      },
      {
        path: "management-attractiveness",
        name: "management-attractiveness",
        component: () => import("./views/ManagementAttractiveness.vue"),
        meta: {
          title: "Attrattività",
        },
      },
      {
        path: "management-destination-access",
        name: "management-destination-access",
        component: () => import("./views/ManagementDestinationAccess.vue"),
        meta: {
          title: "Accesso alla destinazioni",
        },
      },
      {
        path: "management-hospitality",
        name: "management-hospitality",
        component: () => import("./views/ManagementHospitality.vue"),
        meta: {
          title: "Accoglienza",
        },
      },
      {
        path: "hospitality-infopoint",
        name: "hospitality-infopoint",
        component: () => import("./views/HospitalityInfoPoint.vue"),
        meta: {
          title: "Accoglienza - Mappa Punti informativi",
        },
      },
      {
        path: "hospitality-initiative",
        name: "hospitality-initiative",
        component: () => import("./views/HospitalityInitiative.vue"),
        meta: {
          title: "Accoglienza - Iniziative",
        },
      },
      {
        path: "hospitality-strategies",
        name: "hospitality-strategies",
        component: () => import("./views/HospitalityStrategies.vue"),
        meta: {
          title: "Accoglienza - Strategie",
        },
      },
      {
        path: "analysis-attractiveness",
        name: "analysis-attractiveness",
        component: () => import("./views/AttractivenessAnalysis.vue"),
        meta: {
          title: "Analisi attrattività - Attrattori",
        },
      },
      {
        path: "analysis-historical-centres",
        name: "analysis-historical-centres",
        component: () => import("./views/HistoricalCentresAnalysis.vue"),
        meta: {
          title: "Analisi attrattività - Centri storici",
        },
      },
      {
        path: "attraction-strategies",
        name: "attraction-strategies",
        component: () => import("./views/AttractionStrategies.vue"),
        meta: {
          title: "Analisi attrattività - Strategie",
        },
      },
      {
        path: "accessibility-strategies",
        name: "accessibility-strategies",
        component: () => import("./views/AccessibilityStrategies.vue"),
        meta: {
          title: "Accesso alla destinazione - Strategie",
        },
      },
      {
        path: "attraction-initiative",
        name: "attraction-initiative",
        component: () => import("./views/AttractionInitiative.vue"),
        meta: {
          title: "Analisi attrattività - Iniziative",
        },
      },
      {
        path: "accessibility-initiative",
        name: "accessibility-initiative",
        component: () => import("./views/AccessibilityInitiative.vue"),
        meta: {
          title: "Accesso alla destinazione - Iniziative",
        },
      },
      {
        path: "product",
        name: "product",
        component: () => import("./views/Product.vue"),
        meta: {
          title: "Prodotti",
        },
      },
      {
        path: "attractors",
        name: "attractors",
        component: () => import("./views/Attractors.vue"),
        meta: {
          title: "Attrattori",
        },
      },
      {
        path: "markets",
        name: "markets",
        component: () => import("./views/Markets.vue"),
        meta: {
          title: "Mercati",
        },
      },
      {
        path: "promotion",
        name: "promotion",
        component: () => import("./views/Promotions.vue"),
        meta: {
          title: "Promozione delle destinazioni",
        },
      },
      {
        path: "promotion-brand-equity",
        name: "promotion-brand-equity",
        component: () => import("./views/PromotionsBrandEquity.vue"),
        meta: {
          title: "Analisi Brand e distribuzione - Brand Equity",
        },
      },
      /* {
        path: "promotion-trip-planning",
        name: "promotion-trip-planning",
        component: () => import("./views/PromotionsTripPlanning.vue"),
        meta: {
          title: "Scelta dei canali informativi e distributivi",
        },
      }, */
      {
        path: "promotion-channel-positioning",
        name: "promotion-channel-positioning",
        component: () => import("./views/PromotionsChannelPositioning.vue"),
        meta: {
          title: "Analisi dei canali informativi e distributivi",
        },
      },
      {
        path: "promotion-strategy-awareness",
        name: "promotion-strategy-awareness",
        component: () => import("./views/PromotionsStrategyBrandAwareness.vue"),
        meta: {
          title: "Affermazione dei brand - Strategie per l'affermazione del brand",
        },
      },
      {
        path: "promotion-initiative-awareness",
        name: "promotion-initiative-awareness",
        component: () => import("./views/PromotionsInitiativeBrandAwareness.vue"),
        meta: {
          title: "Affermazione dei brand - Iniziative per l'affermazione del brand",
        },
      },
      {
        path: "promotion-strategy-visibility",
        name: "promotion-strategy-visibility",
        component: () => import("./views/PromotionsStrategyVisibility.vue"),
        meta: {
          title: "Strategie per la visibilità e l'acquistabilità dell'offerta",
        },
      },
      {
        path: "promotion-initiative-visibility",
        name: "promotion-initiative-visibility",
        component: () => import("./views/PromotionsInitiativeVisibility.vue"),
        meta: {
          title: "Affermazione dei brand - Iniziative per la visibilità e l'acquistabilità del brand",
        },
      },
      {
        path: "environment-plan",
        name: "environment-plan",
        component: () => import("./views/EnvironmentPlan.vue"),
        meta: {
          title: "Piano operativo annuale",
        },
      },
      {
        path: "object-initiative-maps",
        name: "object-initiative-maps",
        component: () => import("./views/ObjectInitiativeMaps.vue"),
        meta: {
          title: "Piano operativo annuale",
        },
      },
      {
        path: "products-markets-matrix",
        name: "products-markets-matrix",
        component: () => import("./views/ProductsMarketsMatrix.vue"),
        meta: {
          title: "Matrice Prodotti Mercati",
        },
      },
      {
        path: "login",
        name: "login",
        component: () => import("./views/Login.vue"),
        meta: { title: "Accedi" },
      },
      {
        path: "*",
        name: "404",
        component: () => import("./views/NotFound.vue"),
        meta: { title: "Pagina non trovata" },
      },
    ],
  },
];

const router = new Router({
  routes,
  mode: "history",
});

router.beforeEach(async (to, from, next) => {
  const logged = store.state.auth.token !== null;

  if (from.name != null) {
    store.commit("app/setPreviousPath", from.path);
  }

  // Handle public routes (e.g.: SSO login)
  if (to.meta.public) return next();

  if (!logged && to.name !== "login") {
    if (to.fullPath !== "/") {
      return next({ name: "login", query: { r: to.fullPath } });
    }
    return next({ name: "login" });
  }

  const defaultRoute = "/dashboard";

  if (logged && (to.name === "login" || to.path === "/")) {
    return next(defaultRoute);
  }

  next();
});

router.afterEach(to => {
  const title = Array.isArray(to.meta.title) ? to.meta.title.join(" - ") : to.meta.title;
  window.document.documentElement.scrollTop = 0;
  window.document.title = `${title} | ${process.env.VUE_APP_TITLE}`;
});

export default router;
